import { Stack, Box } from '@mui/material';
import { useState } from 'react';
import { FileInputButton } from './FileInput';
import { ImageFromFile } from './images/ImageFromFile';
import { ImageFromServer } from './images/ImageFromServer';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

export const ImageAdder = (props: { imageFileIds: Array<string>; filesUpdated: (files: Array<File>) => void; fileIdsUpdated: (fileIds: Array<string>) => void }) => {
  const [files, setFiles] = useState<Array<File>>([]);

  return (
    <Stack direction={'row'} sx={{ alignContent: 'center', justifyContent: 'flex-start', justifyItems: 'start', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
      {props.imageFileIds.map((f) => (
        <Box sx={{ position: 'relative', '&:hover .overlayIcon': { opacity: 1 } }}>
          <ImageFromServer thumbnail={false} sx={{ width: 50, height: 50, objectFit: 'cover' }} alt="no image" id={f} />
          <DeleteIcon
            onClick={() => {
              props.fileIdsUpdated(props.imageFileIds.filter((fid) => fid !== f));
            }}
            className="overlayIcon"
            sx={{ position: 'absolute', bottom: 5, right: 1, opacity: 0 }}
          />
        </Box>
      ))}
      {files.map((f) => (
        <ImageFromFile thumbnail={true} sx={{ width: 50, height: 50 }} image={f} />
      ))}
      <FileInputButton
        sx={{ borderColor: 'common.white', color: 'common.white', minWidth: 50, width: 50, height: 50 }}
        onFilePicked={(file) => {
          if (file) {
            const updatedFiles = [...files, file];
            setFiles(updatedFiles);
            props.filesUpdated(updatedFiles);
          }
        }}
      >
        <AddIcon />
      </FileInputButton>
    </Stack>
  );
};
